import { render, staticRenderFns } from "./VwTxMapper.vue?vue&type=template&id=fff4c82a&scoped=true&lang=pug&"
import script from "./VwTxMapper.vue?vue&type=script&lang=ts&"
export * from "./VwTxMapper.vue?vue&type=script&lang=ts&"
import style0 from "./VwTxMapper.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./VwTxMapper.vue?vue&type=style&index=1&id=fff4c82a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff4c82a",
  null
  
)

component.options.__file = "VwTxMapper.vue"
export default component.exports